/*
#Copyright 2025 Pixagan Technologies

# Licensed under the Apache License, Version 2.0 (the "License");
# you may not use this file except in compliance with the License.
# You may obtain a copy of the License at
#
#     http://www.apache.org/licenses/LICENSE-2.0
#
# Unless required by applicable law or agreed to in writing, software
# distributed under the License is distributed on an "AS IS" BASIS,
# WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
# See the License for the specific language governing permissions and
# limitations under the License.
*/

export const LOAD_CURRENT_FLOW = 'LOAD_CURRENT_FLOW';
export const CURRENT_FLOW_FAIL = 'CURRENT_FLOW_FAIL';
export const RESET_CURRENT_FLOW = 'RESET_CURRENT_FLOW';

export const LOAD_APP_STATE = 'LOAD_APP_STATE';
export const APP_STATE_FAIL = 'APP_STATE_FAIL';
export const RESET_APP_STATE = 'RESET_APP_STATE';
export const UPDATE_APP_STATE = 'UPDATE_APP_STATE';